import React from "react";
import { Box, Switch, Tooltip } from "@mui/material";
import {
  getSiStatus,
  getSiStatusColor,
  normalizeSi,
} from "./siUtils";

export function resolveTaskId(row) {
  const original = row?.original ?? row;
  return original?.scheduleTaskId ?? original?.id ?? null;
}

export function isGroupTaskRow(original) {
  if (!original) return true;
  if (original._isGroup) return true;
  const id = original.id ?? original.scheduleTaskId;
  return id != null && String(id).startsWith("group-");
}

export function SiTableCell({
  row,
  onSiChange,
  siUpdatingIds,
  readOnly = false,
}) {
  const original = row?.original ?? row;
  const taskId = resolveTaskId(row);
  const isGroup = isGroupTaskRow(original);
  const status =
    original._siStatus ??
    getSiStatus({
      si: original.si,
      plannedEnd:
        original.revisedEnd ||
        original.plannedEnd ||
        original.endDate ||
        original.targetDate ||
        original.baselineEnd,
    });

  if (readOnly || isGroup || !taskId || !onSiChange) {
    return (
      <Tooltip
        title={
          status === "complete"
            ? "Complete"
            : status === "overdue"
              ? "Overdue"
              : "In progress"
        }
      >
        <Box
          sx={{
            width: 14,
            height: 14,
            borderRadius: "50%",
            bgcolor: getSiStatusColor(status),
            mx: "auto",
          }}
        />
      </Tooltip>
    );
  }

  const checked = normalizeSi(original.si) === 1;
  const updating =
    siUpdatingIds instanceof Set && siUpdatingIds.has(String(taskId));

  return (
    <Switch
      checked={checked}
      disabled={updating}
      size="small"
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        e.stopPropagation();
        onSiChange?.(original);
      }}
    />
  );
}

export function buildSiColumn({ onSiChange, siUpdatingIds, readOnly } = {}) {
  return {
    accessorKey: "si",
    header: "SI",
    size: 72,
    enableEditing: false,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ row }) => (
      <SiTableCell
        row={row}
        onSiChange={onSiChange}
        siUpdatingIds={siUpdatingIds}
        readOnly={readOnly}
      />
    ),
  };
}
